export default "__VITE_ASSET__e5669122__"